import { render } from "./SortComponent.vue?vue&type=template&id=1d2d404e&ts=true"
import script from "./SortComponent.vue?vue&type=script&lang=ts"
export * from "./SortComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__